var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.832 31.0037C45.796 35.2327 26.951 52.6447 21.332 73.9667C16.403 92.6707 23.155 119.342 33.593 122.395C36.114 123.132 50.913 123.389 79.01 123.182C119.46 122.884 120.771 122.813 123.51 120.787C126.695 118.429 128.705 114.791 132.022 105.375C133.876 100.113 134.312 96.7797 134.312 87.8747C134.312 76.2017 132.34 67.9977 127.71 60.4047L125.594 56.9357L123.293 59.8207C118.636 65.6617 118.355 66.8577 120.289 72.6047C123.995 83.6187 123.314 98.3947 118.676 107.625L116.791 111.375H77.011H37.231L35.019 106.824C22.827 81.7277 39.603 49.3357 67.94 43.2587C74.514 41.8487 84.585 42.5387 92.066 44.9107C98.316 46.8937 99.464 46.6357 105.386 41.9137L108.271 39.6127L104.802 37.4767C98.754 33.7547 88.915 31.1937 79.332 30.8477C74.382 30.6697 69.207 30.7397 67.832 31.0037ZM104.689 56.0277C98.443 60.2367 88.082 67.2057 81.664 71.5157C75.247 75.8247 69.059 80.5417 67.914 81.9977C64.078 86.8747 65.933 95.7327 71.304 98.1797C75.154 99.9337 81.2851 99.6577 83.6241 97.6247C84.7321 96.6617 92.136 86.1997 100.078 74.3747C114.218 53.3187 117.336 48.3747 116.474 48.3747C116.239 48.3747 110.935 51.8187 104.689 56.0277Z",
    fill: "#425466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.91dd17fb343e77c83dd764dff9d7d4ed.svg";
export { ForwardRef as ReactComponent };